<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <v-sheet class="neu-glow with-radius" max-width="500">
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" class="px-5 pos-relative">
                  <div class="mt-8 mb-8 text-center">
                    <div class="text-h4 d-flex justify-center align-center">
                      <v-img
                          src="/static/fs/symbol-logo_fs_sinfondo.png"
                          lazy-src="/static/fs/symbol-logo_fs_sinfondo.png"
                          alt="Logo Futurespace"
                          max-width="50px"
                      ></v-img>
                      <span class="ml-3"><h4 class="primary--text">{{ $t('Global.Main.appName') }}</h4></span>
                    </div>
                    <div class="text-subtitle-1">{{ stepsDetails.title }}</div>
                    <div class="text-body-2">{{ stepsDetails.subtitle }}</div>
                  </div>
                  <reset-password @complete="completeProcess()"  :token="$route.params.data"/>
                  <v-btn
                    icon
                    absolute
                    top
                    right
                    to="/site/admin"
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
        v-model="snackbar"
        top
        right
        :timeout="snackbarTimeout"
        :color="snackbarColor"
        class="mt-6"
    >
      <span>{{ snackbarMessage }}</span>
      <v-icon class="ml-2" dark>{{ snackbarIcon }}</v-icon>
      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          {{ $t("Global.ConfirmDialog.buttonTextClose") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-sheet>
</template>

<script>
import Utils from "@/mixins/Utils";
import snackBar from "@/mixins/snackBarMixin";

export default {
  name: 'AssignPassword',
  components: {
    ResetPassword: () => import("./Partials/ResetPassword"),
  },
  mixins: [Utils, snackBar],
  data() {
    return {
      stepsDetails: [
        {
          title: this.$t("Global.ForgotPassword.setNewPasswordText"),
          subtitle: null
        },
      ],
      resetPasswordToken: null,
      userLogin: null,
      expirationTokenDate: null,
      validDateToken: false,
    };
  },
  methods: {
    completeProcess() {
      const time = 2000
      this.launchSnackbar(this.$t("Global.AssignPassword.passwordResetSuccessfully"),'success',`${time}`,'mdi-check-circle')
      setTimeout(() => {
        this.$router.push({
          name: "Login",
        });
      }, time);
    },
  },
};
</script>
